interface IRenexisAppLogoMarkSVGViewProps {
  className?: string;
  /**
   * It will show logo in two different colors. By default it will be white.
   */
  invert?: boolean;
  /**
   * It will set logo opacity. By default it will be 1.
   */
  opacity?: number;
}

/**
 * -----------------------------------------------------------------------------
 *  It will show markup of X icon of the logo in white or black color.
 */
export function RenexisAppLogoMarkSVG({
  className,
  invert = false,
  opacity = 1,
}: Readonly<IRenexisAppLogoMarkSVGViewProps>) {
  return (
    <svg
      className={className}
      fill="none"
      style={{ maxWidth: 370 }}
      viewBox="0 0 370 362"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={invert ? 'fill-black' : 'fill-white'}
        d="M364.202 316.553c-11.596 28.075-37.635 45.421-67.945 45.421-19.62 0-38.101-7.678-52.001-21.482l-93.285-93.247c-11.105-11.09-25.082-17.76-39.603-20.06-2.847-.388-5.642-.647-8.49-.724-18.895-.724-37.945 6.023-52.466 20.06L18.73 277.388l-.233.233c-11.44 11.349-7.377 24.585-5.798 28.462 1.579 3.8 7.946 16.338 24.383 16.338a26.285 26.285 0 0 0 18.429-7.522l9.758-9.746-2.925-2.379c-11.104-8.97-7.687-26.73 5.953-30.918l23.969-7.445 23.347-8.971c13.33-5.144 26.997 6.67 23.891 20.604l-3.028 13.313-.078.233-2.459 10.78-3.883 24.74c-2.226 14.115-19.283 20.061-29.844 10.315l-4.84-4.524-11.906 11.969c-12.554 12.357-28.965 19.104-46.358 19.104-27.308 0-50.733-15.692-61.035-41-5.642-13.883-6.419-28.308-2.847-41.699 3.029-11.168 9.06-21.56 17.938-30.22l31.604-30.815c43.355-42.112 113.449-41.621 156.157 1.034l93.363 93.246c6.42 6.411 14.935 9.901 23.969 9.901 14.21 0 25.961-7.858 31.449-20.939 4.84-11.814 3.106-24.094-4.608-33.685a42.017 42.017 0 0 0-2.847-3.257l-59.377-59.226c-17.55-17.45-23.658-42.345-18.016-64.939a66.457 66.457 0 0 1 17.136-31.228l52.389-54.082c9.137-9.435 11.518-22.206 6.419-34.33-1.346-3.18-3.106-6.024-5.229-8.402-5.798-6.903-14.21-10.858-23.891-10.858-8.412 0-16.669 3.49-22.544 9.436L215.37 63.389c-12.787 12.926-29.844 20.061-48.041 20.061h-.077c-18.171 0-35.177-7.057-47.937-19.983L67.236 10.911C61.361 4.965 53.181 1.475 44.77 1.475c-10.716 0-19.93 4.834-25.65 13.159a33.324 33.324 0 0 0-3.418 6.1c-5.15 12.047-2.77 24.818 6.342 34.254l.388.388 53.502 58.579 31.216 34.357c-15.944-1.345-32.225.879-47.47 6.488L-6.586 82.21C-23.72 64.371-30.165 40.277-24.6 17.037A74.175 74.175 0 0 1-20.717 5.3C-9.38-21.429 15.7-38 44.769-38c18.895 0 37.299 7.704 50.655 21.095l52.001 52.556c5.306 5.403 12.372 8.324 19.853 8.324 7.532-.078 14.598-2.921 19.93-8.324l51.768-52.479C252.203-30.296 270.684-38 289.656-38c29.042 0 54.227 16.57 65.564 43.379.803 1.835 1.424 3.645 1.993 5.48 8.568 25.206 2.459 52.246-16.358 71.764l-52.467 54.081a13.517 13.517 0 0 0-1.423 1.655c-9.448 11.349-8.801 28.462 1.837 39.01l59.456 59.148c8.412 8.402 14.52 18.225 18.015 28.85 5.487 16.235 4.995 34.228-2.071 51.186Z"
        fillOpacity={opacity}
      />
    </svg>
  );
}
